import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { NotificationSettingsForm } from "Components/Settings/NotificationSettingsForm";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import {
  getUserNotificationSettingsAsync,
  saveUserNotificationSettingsAsync,
} from "State/Notification/Settings/UserNotificationSettingsState";
import type { RootStateType } from "State/Store";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

/**
 * @deprecated This component is obsolete and should not be used.
 * NotificationSettingsPage is obsolete.
 */
export const NotificationSettingsPage = () => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getUserNotificationSettingsAsync.request());

    return () => {
      dispatch(getUserNotificationSettingsAsync.success(null));
    };
  }, [dispatch]);

  const { notificationSettings } = useSelector(
    (e: RootStateType) => e.notification,
  );

  return (
    <AuthenticatedLayout title="Notifikace">
      <StyledPageWrapper>
        <div className="left-content">
          {!!notificationSettings && (
            <PrimaryPaper>
              <NotificationSettingsForm
                model={notificationSettings}
                onSubmit={(e) =>
                  dispatch(saveUserNotificationSettingsAsync.request(e))
                }
              />
            </PrimaryPaper>
          )}
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default NotificationSettingsPage;
